import { render } from "./BusinessUnitSlug.vue?vue&type=template&id=6b3b7164"
import script from "./BusinessUnitSlug.vue?vue&type=script&lang=js"
export * from "./BusinessUnitSlug.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__